import 'react-spring-bottom-sheet/dist/style.css';
import './custom-react-spring-bottom-sheet.style.css';
import React from 'react';
import { BottomSheet as BottomSheetLib } from 'react-spring-bottom-sheet';
import { useWindowSize } from '@yme/common/hooks';
export const BottomSheet = ({ children, ...props }) => {
    const { isInfiniteDesktopView } = useWindowSize();
    if (isInfiniteDesktopView) {
        return null;
    }
    return React.createElement(BottomSheetLib, { ...props }, children);
};
